'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

// Following MUI z-index convention
// https://mui.com/material-ui/customization/z-index/
const zIndex = {
  Toolbar: 1000,
  Fab: 1050,
  AppBar: 1100,
  Drawer: 1200,
  Modal: 1300,
  Snackbar: 1400,
  Tooltip: 1500
};

exports.zIndex = zIndex;
